import { actionCreatorTypeExtractor, actionNotifier } from './notifyActionMiddleware';
import { logActionCallback, resizedLogActionCallback } from './logActionCallback';
import { userLoadedAction } from '@/store/state/user/user.actions';

export const logActionMiddleware = actionNotifier({
  didMatch: resizedLogActionCallback,
  didNotMatch: logActionCallback,
  actionsList: [userLoadedAction].map(actionCreatorTypeExtractor),
});
